import type { AssistantSubagentPart } from "../../../chat/types";

/** Latest human-readable activity line for a running subagent, scanning
 *  events newest-first. Null when not running or no summarisable event.
 *  Shared by SubagentCard (in-thread) and RunningTasksStrip (above composer)
 *  so the two surfaces never diverge. */
export function subagentLiveActivity(part: AssistantSubagentPart): string | null {
  if (part.status !== "running") return null;
  for (let i = part.events.length - 1; i >= 0; i--) {
    const e = part.events[i];
    if (e.kind === "thinking" && e.data?.text) return String(e.data.text);
    if (e.kind === "tool_use" && e.data?.tool) return `Using ${e.data.tool}…`;
    if (e.kind === "tool_result" && e.data?.tool) return `Got result from ${e.data.tool}`;
  }
  return null;
}
